module.exports = __webpack_public_path__ + "static/media/etchdemo.51584504.gif";